<template>
  <v-sheet :class="$vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'">
    <v-card-text class="trade">
      <div class="icon-wrapper-body">
        <div class="icon-wrapper">
          <div class="icon-box">
            <slot name="icon">
              <!-- paste Partners svg here -->
            </slot>
          </div>

          <div class="icon-content">
            <h3>Partners</h3>
            <span>Account</span>
          </div>
        </div>

        <div class="badgeClass icon-badge">
          <i>+1 new</i>
        </div>
      </div>

      <p class="amount">
        <span v-if="allPartners">
          <countTo :startVal="startVal" :endVal="parseAmount(allPartners)" :duration="3000" />
        </span>
        <span v-else>0</span>

        <router-link class="links" to="/partner-list">See All</router-link>
      </p>
    </v-card-text>
  </v-sheet>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { DASHBOARDAPIREQ__ACTIONS } from "@/store/action-types";
import countTo from "vue-count-to";
import { parseAmount } from "./utils";

export default {
  components: { countTo },
  data: () => ({ startVal: 0 }),
  computed: {
    ...mapState("dashboard", ["allPartners"]),
  },
  methods: {
    ...mapActions("dashboard", [DASHBOARDAPIREQ__ACTIONS.TOTALPARTNERS]),
    parseAmount,
  },
  async created() {
    await this[DASHBOARDAPIREQ__ACTIONS.TOTALPARTNERS]();
  },
};
</script>
